import { Page } from '../../../../components/page/page';
import { HasAccess } from '../../../../features/has-access/has-access';
import { TaskCards } from './task-cards/tasks-cards';
import s from './task-list.module.css';
import { TasksControls } from './tasks-controls/tasks-controls';
import { TasksCreateTaskModal } from './tasks-controls/tasks-create-task-modal/tasks-create-task-modal';
import { TasksCallbackModal } from './tasks-info/tasks-callback-modal/tasks-callback-modal';
import { TasksFormModal } from './tasks-info/tasks-form-modal/tasks-form-modal';
import { TaskInfoModal } from './tasks-info/tasks-info-modal/tasks-info-modal';
import { TaskMarks } from './tasks-marks/tasks-marks';
import { TasksTable } from './tasks-table/tasks-table';
import { useTaskList } from './use-task-list';

export const TaskList = () => {
  const {
    t,
    pagination,
    viewStyle,
    handleEnd,
    pageTitle,
    taskCallbackModal,
    taskFormModal,
    taskInfoModal,
    createTaskModal,
  } = useTaskList();

  return (
    <HasAccess service="task" permissions={['read', 'write']}>
      <Page className={s.page}>
        <div className={s.header}>
          <h2>
            {t(pageTitle)} ({pagination?.count})
          </h2>
          <TasksControls />
        </div>

        <TaskMarks />

        {viewStyle === 'table' ? <TasksTable key={pageTitle} /> : <TaskCards onEnd={handleEnd} />}

        {taskInfoModal.isOpen && (
          <TaskInfoModal onClose={() => taskInfoModal.handleCloseModal(['taskId'])} />
        )}
        <HasAccess service="task" permissions={['write']}>
          {createTaskModal.isOpen && (
            <TasksCreateTaskModal onClose={() => createTaskModal.handleCloseModal()} />
          )}
        </HasAccess>
        {taskFormModal.isOpen && (
          <TasksFormModal onClose={() => taskInfoModal.handleCloseModal(['form'])} />
        )}
        {taskCallbackModal.isOpen && (
          <TasksCallbackModal onClose={() => taskCallbackModal.handleCloseModal(['callback'])} />
        )}
      </Page>
    </HasAccess>
  );
};
